import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import styles from "./reportTable.module.scss";

class ReportTablePivot extends Component {
  render() {
    const { pivot } = this.props;

    if (pivot.length === 0) return null;

    return (
      <div style={{ display: "flex" }}>
        {pivot.map((item) => {
          return (
            <div key={uuidv4()} className={styles.reportTableRowItem} style={{ minWidth: item.width + "px" }}>
              <b>{item.value}</b>
            </div>
          );
        })}
      </div>
    );
  }
}

export default React.memo(ReportTablePivot);
